import { combineReducers } from 'redux';

import { UserGroups } from '../constants';
import { Actions as UserActions, ActionTypes as UserActionTypes } from '../user/actions';
import { Actions, ActionTypes } from './actions';

export interface ISessionState {
	isValid: boolean;
	accessToken: string;
	idToken: string;
	username: string;
	attributes: { [key: string]: string };
	ownerId: string;
	groups: UserGroups[];
}

const defaultSession = (): ISessionState => ({
	isValid: false,
	accessToken: '',
	idToken: '',
	attributes: { email: '' },
	username: '',
	ownerId: '',
	groups: [] as UserGroups[]
});

export const current = (state: ISessionState = defaultSession(), action: Actions | UserActions = {} as any) => {
	switch (action.type) {
		case ActionTypes.SESSION_CREATE_FAILURE:
			return { ...state, isValid: false };
		case ActionTypes.SESSION_CREATE_RECEIVE:
			return {
				...state,
				isValid: true,
				accessToken: action.payload.accessToken,
				idToken: action.payload.idToken,
				ownerId: action.payload.attributes['custom:internalOwnerId'],
				username: action.payload.attributes.username,
				attributes: action.payload.attributes,
				groups: action.payload.groups
			};
		case UserActionTypes.USER_CREATE_RECEIVE:
			return {
				...state,
				username: action.payload.username,
				ownerId: action.payload.ownerId
			};
		case UserActionTypes.USER_UPDATE_RECEIVE:
			const ownerId = action.payload['custom:internalOwnerId'] || state.ownerId;
			const username = action.payload.email || state.username;
			const accessToken = 'accessToken' in action.payload ? action.payload.accessToken : state.accessToken;
			const idToken = 'idToken' in action.payload ? action.payload.idToken : state.idToken;

			return {
				...state,
				ownerId,
				username,
				accessToken,
				idToken
			};
		case ActionTypes.SESSION_DESTROY:
		case ActionTypes.SESSION_INVALID:
			return defaultSession();
		default:
			return state;
	}
};

export interface IAuthState {
	current: ReturnType<typeof current>;
}

const auth = combineReducers<IAuthState>({
	current
});

export default auth;
